import React from "react"
import "./Terms.css"

function Terms() {
  return (
    <div className='Terms'>
      <div>
        <h1>Terms of Service</h1>
        <p className='last-updated'>
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the 528 mobile application and related
            services ("the Service"), you agree to be bound by these Terms of
            Service ("Terms"). If you disagree with any part of these terms, you
            may not access the Service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            528 Entertainment SJ provides facilities for recreational
            activities, including but not limited to murder mystery games, board
            games (such as Catan), and other gathering games. We also provide
            facilities for social entertainment events. Our mobile application
            allows you to browse our services, make reservations, and manage
            bookings.
          </p>
        </section>

        <section>
          <h2>3. User Accounts and Registration</h2>
          <p>
            To use certain features of our Service, you may need to create an
            account. You agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your information to keep it accurate</li>
            <li>Maintain the security of your account credentials</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>
              Notify us immediately of any unauthorized use of your account
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Reservations and Bookings</h2>
          <p>When making a reservation through our Service:</p>
          <ul>
            <li>You agree to provide accurate booking information</li>
            <li>Reservations are subject to availability</li>
            <li>
              We reserve the right to cancel or modify reservations at our
              discretion
            </li>
            <li>
              Refund and cancellation policies are as specified at the time of
              booking
            </li>
            <li>Late arrivals may result in forfeiture of your reservation</li>
          </ul>
        </section>

        <section>
          <h2>5. Payment Terms</h2>
          <p>Payment terms include:</p>
          <ul>
            <li>
              All prices are as displayed and are subject to change without
              notice
            </li>
            <li>
              Payment is required at the time of booking or as otherwise
              specified
            </li>
            <li>We accept various payment methods as indicated in the app</li>
            <li>
              All sales are final unless otherwise specified in our refund
              policy
            </li>
            <li>You are responsible for any additional fees or charges</li>
          </ul>
        </section>

        <section>
          <h2>6. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any illegal or unauthorized purpose</li>
            <li>Violate any laws in your jurisdiction</li>
            <li>Infringe on the rights of others</li>
            <li>Transmit any harmful, offensive, or inappropriate content</li>
            <li>Interfere with or disrupt the Service or servers</li>
            <li>Attempt to gain unauthorized access to the Service</li>
            <li>
              Use automated systems to access the Service without permission
            </li>
          </ul>
        </section>

        <section>
          <h2>7. Intellectual Property</h2>
          <p>
            All content, features, and functionality of the Service, including
            but not limited to text, graphics, logos, images, and software, are
            the exclusive property of 528 Entertainment SJ and are protected by
            copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2>8. Disclaimer of Warranties</h2>
          <p>
            The Service is provided "as is" and "as available" without
            warranties of any kind, either express or implied. We do not warrant
            that the Service will be uninterrupted, secure, or error-free. Your
            use of the Service is at your sole risk.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, 528 Entertainment SJ shall
            not be liable for any indirect, incidental, special, consequential,
            or punitive damages, or any loss of profits or revenues, whether
            incurred directly or indirectly, or any loss of data, use, goodwill,
            or other intangible losses resulting from your use of the Service.
          </p>
        </section>

        <section>
          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless 528 Entertainment SJ, its
            officers, directors, employees, and agents from any claims, damages,
            losses, liabilities, and expenses (including legal fees) arising out
            of your use of the Service, violation of these Terms, or
            infringement of any rights of another.
          </p>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your account and access
            to the Service immediately, without prior notice, for conduct that
            we believe violates these Terms or is harmful to other users, us, or
            third parties, or for any other reason.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will
            notify users of material changes by posting the updated Terms in the
            app and updating the "Last Updated" date. Your continued use of the
            Service after such changes constitutes acceptance of the updated
            Terms.
          </p>
        </section>

        <section>
          <h2>13. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the State of California, without regard to its conflict
            of law provisions.
          </p>
        </section>

        <section>
          <h2>14. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please
            contact us:
          </p>
          <ul>
            <li>Email: support@528entertainment.com</li>
            <li>Customer Service: Via Google Business Chat or WeChat</li>
            <li>
              Address: 528 Entertainment SJ, 1715 Lundy Ave, Ste 138, San Jose,
              CA 95131
            </li>
          </ul>
        </section>
      </div>
    </div>
  )
}

export default Terms
